import { RoutePathType } from './enums';

export const CLIENTLESS_ROUTES = [
  RoutePathType.Activation,
  RoutePathType.ChangePassword,
  RoutePathType.ExpiredToken,
  RoutePathType.ForgotPassword,
  RoutePathType.Login,
  RoutePathType.ExternalDocumentViewer,
];
